import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchTemplates } from '../../store/actions/broadcastAction';
import Header from '../../components/Header'
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../../components/Menubar';
import { Button, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Typography, Box, Chip } from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';
import FileUploadSharpIcon from '@mui/icons-material/FileUploadSharp';
import FileDownloadSharpIcon from '@mui/icons-material/FileDownloadSharp';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import FilterAltSharpIcon from '@mui/icons-material/FilterAltSharp';
import ArrowDropDownSharpIcon from '@mui/icons-material/ArrowDropDownSharp';
import Moment from "moment"

const useStyles = makeStyles((theme) => ({
    appBar: {
      position: 'relative',
    },
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    stepper: {
      padding: theme.spacing(3, 0, 5),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "0%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
}));

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

const columns = [
  { 
    id: 'name', 
    label: 'Nama', 
    minWidth: 170 
  },
  { 
    id: 'category', 
    label: 'Kategori', 
    minWidth: 170 
  },
  { 
    id: 'createdAt', 
    label: 'Tanggal Pembuatan', 
    minWidth: 170,
    align: 'center', 
    type: "dateTime",
  },
  { 
    id: 'updatedAt', 
    label: 'Update Terakhir', 
    minWidth: 170,
    align: 'center', 
    type: "dateTime",
  },
  {
    id: 'status',
    label: 'Status',
    minWidth: 100,
    align: 'center'
  },
  {
    id: 'action',
    label: 'Aksi',
    minWidth: 100,
    align: 'center'
  }
];


const TemplateSubmission = () => {
  const dispatch = useDispatch()
  const classes = useStyles();
  const history = useHistory()
    
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleNewBroadcast = () => {
    history.push('/broadcast/newBroadcast')
  }

  useEffect(() => {
    dispatch(fetchTemplates())
  }, [dispatch])

  const templates = useSelector(state => state.broadcastReducer.templates)

  useEffect(() => {
    const rowsData = []
    templates?.forEach(data => {
      switch (data.type) {
        case 'text':
          data.category = 'Pesan'
          break;
        case 'image':
          data.category = 'Gambar'
          break;
        case 'pdf':
          data.category = 'Dokumen'
          break;
        default:
          break;
      }

      const dt = Moment(data.createdAt).format('DD MMMM YYYY')
      const tm = Moment(data.createdAt).format('HH:mm')
      const tz = new Date(data.createdAt).getTimezoneOffset() < 0 ?
                  `+${-(new Date(data.createdAt).getTimezoneOffset()/60)}`
                  :
                  `-${-(new Date(data.createdAt).getTimezoneOffset()/60)}`
      data.createdAt = `${dt} | ${tm} (GMT ${tz})`

      const dt_u = Moment(data.updatedAt).format('DD MMMM YYYY')
      const tm_u = Moment(data.updatedAt).format('HH:mm')
      const tz_u = new Date(data.updatedAt).getTimezoneOffset() < 0 ?
                  `+${-(new Date(data.updatedAt).getTimezoneOffset()/60)}`
                  :
                  `-${-(new Date(data.updatedAt).getTimezoneOffset()/60)}`
      data.updatedAt = `${dt_u} | ${tm_u} (GMT ${tz_u})`


      // if (data.status === 'success') {
      //   rowsData.push({
      //     id: data._id,
      //     name: data.customerName,
      //     date: data.timestamp,
      //     login: data.category,
      //     status: <Chip icon={<CircleIcon className='font-size-10 text-green' />} label="Berhasil" variant="outlined" />  
      //   })      
      // } else {
      //   rowsData.push({
      //     id: data._id,
      //     name: data.customerName,
      //     date: data.timestamp,
      //     login: data.category,
      //     status: <Chip icon={<CircleIcon className='font-size-10 text-red' />} label="Gagal" variant="outlined" />
      //   })      
      // }
      rowsData.push({
        id: data._id,
        name: data.name,
        category: data.category,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt,
        status: <Chip icon={<CircleIcon className='font-size-10 text-green' />} label="Disetujui" variant="outlined" />  
      })      
    })
    setRows(rowsData)
  }, [templates])
          
  return (
        <React.Fragment>
        <Header page='Templates'/>
        <CssBaseline />
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentCreateApp}>
          <main className={classes.layoutMainCreateApp}>
            <Grid container style={{position: 'relative'}}>
              <Box className="d-flex mb-15 w-100" style={{ justifyContent: 'space-between' }}>
                <div className="d-flex" style={{justifyContent:'space-between'}}>
                  <Search style={{border: "1px solid #dadada"}}>
                    <SearchIconWrapper>
                      <SearchIcon />
                    </SearchIconWrapper>
                    <StyledInputBase
                      placeholder="Cari Template"
                      className="font-size-14 mr-5"
                      inputProps={{ 'aria-label': 'search' }}
                    />
                  </Search>
                  <div className="d-flex ml-5" style={{justifyContent:"space-between", padding:"4px 3px", border: "1px solid #dadada"}}>
                    <FilterAltSharpIcon />
                    <ArrowDropDownSharpIcon />
                  </div>
                </div>
                <div className="d-flex" style={{justifyContent:'space-between'}}>
                  <span className="font-size-14 mt-5 mr-5"> Urut Berdasarkan: </span>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <NativeSelect
                        defaultValue={30}
                        inputProps={{
                          name: 'age',
                          id: 'uncontrolled-native',
                        }}
                        variant='outlined'
                        className="font-size-14"
                      >
                        <option value={10}>Status</option>
                        <option value={20}>Terlama</option>
                        <option value={30}>Terbaru</option>
                      </NativeSelect>
                    </FormControl>
                  </Box>
                </div>
              </Box>
              <Paper sx={{ width: '100%', overflow: 'hidden' }} className={classes.tableRoot}>
                <TableContainer sx={{ maxHeight: 380 }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          Nama Template
                        </TableCell>
                        <TableCell  align="center">
                          Kategori
                        </TableCell>
                        <TableCell align="center">
                          Tanggal Pembuatan
                        </TableCell>
                        <TableCell align="center">
                          Update Terakhir
                        </TableCell>
                        <TableCell align="center">
                          Status
                        </TableCell>
                        <TableCell align="center">
                          Aksi
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody stripedRows >
                      {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                          return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                              {columns.map((column) => {
                                const value = row[column.id];
                                return (
                                  <TableCell key={column.id} align={column.align}>
                                    {column.format && typeof value === 'number'
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>

          </main>
        </Grid>
      </React.Fragment>     
    )
}

export default TemplateSubmission
